import TextInput from "@presentation/shared/components/text-input/TextInput";
import { Button } from "@presentation/shared/components/button/Button";
import { useMemo, useState } from "react";
import { useService } from "@infrastructure/api/hooks/use-service";
import { Requests } from "@infrastructure/api/requests";
import { cx } from "@presentation/vendor/classnames";
import { T } from "@config/lang";
import { useTheme } from "@presentation/theme/useTheme";

const EMAIL_REGEX = /^[\w-.]+@([A-Z0-9-]+\.)+[A-Z]{2,}$/i;

export function NewsLetter() {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);
  const { newsletter } = useTheme();

  const isValid = useMemo(() => email && EMAIL_REGEX.test(email), [email]);

  const { loading, requestAsync } = useService(Requests.newsletter);

  const onSubmit = () => {
    requestAsync({ email }).then(() => {
      setEmail("");
      setSubscribed(true);
    });
  };

  return (
    <aside
      className={cx(
        "py-16 text-center bg-primary-100 bg-opacity-30 flex flex-col items-center",
        {
          "opacity-30": loading,
          ["bg-" + newsletter?.background]: newsletter?.background,
        }
      )}
    >
      <h3 className="mb-3 text-xl font-medium text-gray-900 dark:text-white">
        {subscribed
          ? T.newsletter.subscribed
          : T.newsletter.subscribe_to_the_newsletter}
      </h3>
      <p className="mb-5 text-sm font-medium text-gray-500 dark:text-gray-300">
        {subscribed
          ? T.newsletter.you_are_now_subscribed
          : T.newsletter.we_will_write_rarely}
      </p>
      {subscribed || (
        <form>
          <div data-style="clean" className="flex items-end mb-3">
            <div
              data-element="fields"
              data-stacked="false"
              className="flex items-center w-full max-w-md mb-3"
            >
              <div className="relative w-full mr-3">
                <label
                  htmlFor="member_email"
                  className="hidden block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                >
                  Email address
                </label>
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <svg
                    className="w-4 h-4 text-primary-500"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
                  </svg>
                </div>
                <TextInput
                  // @ts-ignore
                  name="member_email"
                  value={email}
                  onChange={setEmail}
                  placeholder={T.newsletter.enter_your_email}
                  inputClassName="formkit-input bg-transparent min-w-[400px] border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
              </div>
              <Button
                type="primary"
                disabled={loading || !isValid}
                onClick={onSubmit}
                className="whitespace-nowrap"
              >
                {T.newsletter.subscribe}
              </Button>
            </div>
          </div>
        </form>
      )}
    </aside>
  );
}
